import { putApi } from '../api/userProfileManager';
export default async (body, hashCode, logger) => {
    await putApi(body, hashCode, `profile/{userId}`, logger);
};
